export const adminSettingProperty = {
  NOMINATIONS_ENABLED: 'nominationsEnabled',
};

export default adminSettingProperty;
